import { computeSummary } from './taxService';

export function validateSubmission(sub, t = (k) => k) {
  const errors = [];
  const warnings = [];

  if (!sub.client_name || !sub.client_name.trim()) errors.push(t('val.client_name_required'));
  if (!sub.client_address || !sub.client_address.trim()) errors.push(t('val.client_address_required'));
  if (!sub.work_type) warnings.push(t('val.work_type_missing'));

  const materials = Array.isArray(sub.materials) ? sub.materials : [];
  const hasItems = materials.some(m => (Number(m.quantity) || 0) > 0 && (Number(m.unit_price) || 0) > 0);

  // Recompute labour using the same logic as taxService (supports both uniform & individuals)
  const labourSummary = computeSummary(materials, sub.labour || {}, 0, 0, sub.province);
  const labourTotal = labourSummary.labourTotal || 0;

  if (!hasItems && labourTotal <= 0) {
    errors.push(t('val.no_items'));
  }
  if (labourTotal <= 0) warnings.push(t('val.no_labour'));

  const summary = sub.summary || {};
  if (!summary.grandTotal || summary.grandTotal <= 0) errors.push(t('val.total_invalid'));
  if (typeof summary.marginPct === 'number' && summary.marginPct < 10) warnings.push(t('val.margin_low'));

  return { errors, warnings, valid: errors.length === 0 };
}
